//Reducer Types
interface State {
  notificationCount?: any;
  notificationData?: any;
  notificationSettingData?: any;
  queueList?: any;
  queueCount?: any;
  exportQueueList?: any;
  exportQueueCount?: any;
}

export const notificationReducer = (
  state: State = {
    notificationCount: 0,
    notificationData: [],
    notificationSettingData: [],
    queueList: [],
    queueCount: 0,
    exportQueueList: [],
    exportQueueCount: 0,
  },
  action: any,
): State => {
  switch (action.type) {
    case "GET_NOTIFICATION_COUNT":
      return {
        ...state,
        notificationCount: action.payload,
      };
    case "GET_NOTIFICATION_DATA":
      return {
        ...state,
        notificationData:
          action.payload.page == 1 || !action.payload.page
            ? action.payload?.data
            : [...state?.notificationData, ...action.payload?.data],
      };
    case "READ_ALL_NOTIFICATION":
      return {
        ...state,
        notificationData: state?.notificationData?.map((item: any) => ({
          ...item,
          read: 1,
        })),
        notificationCount: 0,
      };

    case "GET_NOTIFICATION_SETTING_DATA":
      return {
        ...state,
        notificationSettingData: action.payload,
      };
    case "READ_NOTIFICATION":
      return {
        ...state,
        notificationData: state?.notificationData?.map((item: any) => ({
          ...item,
          read: item?._id == action.payload?.id ? 1 : item?.read,
        })),
        notificationCount: action.payload?.isRead
          ? state?.notificationCount
          : Math.max(0, state?.notificationCount - 1),
      };
    case "UPDATE_NOTIFICATION_SETTING":
      return {
        ...state,
        notificationSettingData: state?.notificationSettingData?.map(
          (elem: any) => {
            if (action?.payload?._id == elem?._id) {
              return action?.payload;
            }
            return elem;
          },
        ),
      };
    case "SOCKET_NEW_NOTIFICATION":
      return {
        ...state,
        notificationData: [action.payload, ...state?.notificationData],
        notificationCount: state?.notificationCount + 1,
      };
    case "GET_QUEUE_LIST":
      return {
        ...state,
        queueList:
          action.payload.page == 1 || !action.payload.page
            ? action.payload?.data
            : [...state?.queueList, ...action.payload?.data],
        queueCount: action.payload?.count,
      };
    case "GET_EXPORT_QUEUE_LIST":
      return {
        ...state,
        exportQueueList:
          action.payload.page == 1 || !action.payload.page
            ? action.payload?.data
            : [...state?.exportQueueList, ...action.payload?.data],
        exportQueueCount: action.payload?.count,
      };
    case "CANCLE_IMPORT_PROGRESS": {
      const updatedQueueList = state?.queueList?.map((elem: any) => {
        if (elem?._id == action?.payload) {
          return { ...elem, status: "cancel" };
        }
        return elem;
      });
      return {
        ...state,
        queueList: updatedQueueList,
      };
    }
    case "CANCLE_EXPORT_PROGRESS": {
      const updatedQueueList = state?.exportQueueList?.map((elem: any) => {
        if (elem?._id == action?.payload) {
          return { ...elem, status: "cancel" };
        }
        return elem;
      });
      return {
        ...state,
        queueList: updatedQueueList,
      };
    }
    default:
      return state;
  }
};
